import { FormEvent, useState } from "react";
import { Link } from "react-router-dom";

const ContactPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    alert(
      `Thank you ${name}. We will get back to you soon.\n\nEmail: ${email}\nMessage: ${message}`,
    );
    setName("");
    setEmail("");
    setMessage("");
  };

  return (
    <div className="az">
      <main className="az-wrap infoPage">
        <div className="crumbs">
          <Link to="/">Home</Link>
          <span>/</span>
          <span>Contact Us</span>
        </div>
        <h1>Contact Us</h1>
        <div className="contactGrid">
          <div>
            <h2>Store in Rawalpindi</h2>
            <p>Pakistan</p>
            <p>
              <a href="mailto:ayzenpk@gmail.com">ayzenpk@gmail.com</a>
              <br />
              <a href="tel:03268615198">0326 8615198</a>
            </p>
            <form className="pageForm" onSubmit={handleSubmit}>
              <label>
                Name
                <input
                  type="text"
                  value={name}
                  placeholder="Your name"
                  onChange={(event) => setName(event.target.value)}
                  required
                />
              </label>
              <label>
                Email
                <input
                  type="email"
                  value={email}
                  placeholder="Email address"
                  onChange={(event) => setEmail(event.target.value)}
                  required
                />
              </label>
              <label>
                Message
                <textarea
                  rows={5}
                  placeholder="Your message"
                  value={message}
                  onChange={(event) => setMessage(event.target.value)}
                />
              </label>
              <button className="cta dark" type="submit">
                Send message
              </button>
            </form>
          </div>
          <iframe
            className="contactMap"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13289.819640782738!2d73.00492078728281!3d33.619444941821996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38df943772a3b733%3A0x5c70a79b764e4daf!2sWestridge%20III%20Westridge%203%2C%20Rawalpindi%2C%20Pakistan!5e0!3m2!1sen!2s!4v1755939646887!5m2!1sen!2s"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Ayzen in Rawalpindi"
          />
        </div>
      </main>
    </div>
  );
};

export default ContactPage;
